// Surface helpers for the Insights page.
//
// Originally a neumorphic set: 20px radii and paired light/dark shadows on an
// off-white ground. The export shape is unchanged so none of the Insights
// cards need touching, but the values now resolve to the app-wide elevation
// system in src/theme/tokens.js — a hairline border plus one soft shadow — so
// Insights and the rest of the portal read as the same product.

import { neutral, brand, signal, radius, elevation, motion } from "../../../../theme/tokens";

export const neumorph = {
  pageBg: neutral[50],
  pageBgSolid: neutral[50],

  raised: {
    bg: neutral[0],
    borderRadius: radius.md,
    border: `1px solid ${neutral[200]}`,
    boxShadow: elevation.raised,
    transition: `box-shadow ${motion.base}, border-color ${motion.base}`,
  },

  raisedHover: {
    borderColor: neutral[300],
    boxShadow: elevation.overlay,
  },

  pressed: {
    bg: neutral[50],
    borderRadius: radius.sm,
    border: `1px solid ${neutral[200]}`,
    boxShadow: "none",
  },

  // Smaller surface — KPI tiles and chips.
  raisedSm: {
    bg: neutral[0],
    borderRadius: radius.sm,
    border: `1px solid ${neutral[200]}`,
    boxShadow: elevation.raised,
    transition: `box-shadow ${motion.fast}, border-color ${motion.fast}`,
  },

  stickyHeader: {
    bg: "rgba(255,255,255,0.86)",
    backdropFilter: "blur(12px)",
    borderBottom: `1px solid ${neutral[200]}`,
    boxShadow: elevation.sticky,
  },

  // Accents — now the shared series/signal palette.
  accentTeal: brand[500],
  accentTealDark: brand[600],
  accentGreen: signal.up,
  accentMint: brand[300],
  accentRed: signal.down,
  accentOrange: signal.warn,

  textMuted: neutral[500],
  textPrimary: neutral[900],
};

// Floating "Details" affordance on BentoCard.
export const detailsBtnSx = {
  position: "absolute",
  top: 3,
  right: 3,
  bg: neutral[0],
  color: brand[500],
  border: `1px solid ${neutral[200]}`,
  borderRadius: radius.sm,
  px: 2,
  py: 1,
  fontSize: "xs",
  fontWeight: "600",
  cursor: "pointer",
  opacity: 0,
  transition: `opacity ${motion.fast}, background-color ${motion.fast}, color ${motion.fast}`,
  boxShadow: elevation.raised,
  _hover: {
    bg: neutral[100],
    color: brand[600],
  },
};
